/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Page_AInputs */

const en_platform_faq_page_a = /** @type {(inputs: Platform_Faq_Page_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your page lives at a web address you choose on this platform. You can hand that link out, put it in your bio and print it on a card.`)
};

const pl_platform_faq_page_a = /** @type {(inputs: Platform_Faq_Page_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja strona ma adres, który wybierasz na tej platformie. Możesz go rozdawać, wkleić w bio i wydrukować na wizytówce.`)
};

/**
* | output |
* | --- |
* | "Your page lives at a web address you choose on this platform. You can hand that link out, put it in your bio and print it on a card." |
*
* @param {Platform_Faq_Page_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_page_a = /** @type {((inputs?: Platform_Faq_Page_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Page_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_page_a(inputs)
	return en_platform_faq_page_a(inputs)
});